import {
    createAttachedSignature,
    getUserCertificates,
    isValidSystemSetup
} from "crypto-pro";
import axios from "axios";
import moment from "moment";
import FilesController from "@/controllers/FilesController";
import {Base64} from "js-base64";
import {mapActions} from "vuex";

export const setCryptoProFunctions = {
    data() {
        return {
            isValidSystemSetup: false,
            errorMessage: null,
            certificates: [],
            certificatesList: [],
            chosenCertificate: null,
            hash: null,
            signature: null,
            signingFile: false
        }
    },

    methods: {
        ...mapActions('checkFilled', {updateFiles: 'updateFiles'}),
        checkSystem() {
            isValidSystemSetup()
                .then(isValidSystemSetup => {
                    this.isValidSystemSetup = isValidSystemSetup;
                    console.log('valid: ', isValidSystemSetup);
                    if (isValidSystemSetup) {
                        this.getCertificates()
                    }
                })
                .catch((e) => {
                        this.isValidSystemSetup = false;
                        console.error(e)
                        this.errorMessage = e.message;
                        this.addNotification({
                            notificationStatus: "error",
                            notificationTime: 10000,
                            notificationMessage: e.message
                        })
                    }
                )
        },
        getCertificates() {
            getUserCertificates().then(async certificates => {
                // console.log('certificates', certificates);
                this.certificates = certificates
                this.certificatesList = (await Promise.all(certificates.map(async (el) => {
                        let isValid;
                        const res = await el._cadesCertificate?.IsValid();
                        isValid = await res.Result;
                        return {value: el.thumbprint, text: el.name, isValid: isValid};
                    })
                )).filter(el => el.isValid)
            }).catch((error) => {
                this.errorMessage = error.message;
                console.error('getCertificates error', error.message)
            })
        },
        createSignature(arrBuf) {
            createAttachedSignature(this.chosenCertificate, arrBuf)
                .then(signature => {
                    this.uploadSingedFile({
                        fileBytes: signature,
                        withoutEncode: false,
                        fileName: `Файл подтверждения введенных данных (подписанный)`,
                        fileFormat: 'pdf'
                    }).then(() => this.signingFile = false)
                })
                .catch(e => this.addNotification({notificationMessage: e.message, notificationStatus: 'error'}))
        },
        async uploadSingedFile(fileData, useFileFormat = true) {
            const file = new File([Base64.toUint8Array(fileData.fileBytes)], fileData.fileName + (fileData.fileFormat && useFileFormat ? '.' + fileData.fileFormat : ''));
            let fd = new FormData();
            fd.append('file', file);
            try {
                await FilesController.saveFile('CONFIRMED_FILE_STAGE_TWO', file, String(this.userId)).then(data => {
                    this.updateFiles(data);
                }).finally(() => {
                        console.log("update files")
                        this.initFiles()
                    }
                )
            } catch (e) {
                console.error(e)
                await this.addNotification({
                    notificationStatus: 'error',
                    notificationMessage: 'Ошибка загрузки',
                    timeout: 3000
                })
            }
        },
        async signFile(alias, nameLoading) {
            if (!this.chosenCertificate) {
                this.addNotification({notificationMessage: 'Выберите сертификат', notificationStatus: 'warning'})
                return;
            }
            if (!this.file) {
                this.addNotification({notificationMessage: 'Ошибка получения файла', notificationStatus: 'warning'})
                return;
            }
            this[nameLoading] = true
            const args = [...arguments].filter((_, i) => i >= 2);
            const cert = this.certificates.filter(el => el.thumbprint === this.chosenCertificate).shift();
            const signargs = args.join('') + `&cert_thumbprint=${cert.thumbprint}&cert_ca=${cert.name}` +
                `&cert_date_start=${moment(cert.validFrom).format("DD.MM.YYYY")}&cert_date_end=${moment(cert.validTo).format("DD.MM.YYYY")}`
            const path = `/api/reports/getByAlias/${alias}${signargs}`;
            await this.downloadBlobDocumentCrypto(path).finally(() => this[nameLoading] = false)
            this.signingFile = true;
            this.changeFileToArrayBuffer().then(arrBuf => {
                this.createSignature(arrBuf)
            })
        },
        changeBlobToBase64(data) {
            return new Promise((res) => {
                const reader = new FileReader();
                reader.readAsDataURL(data);
                reader.onloadend = () => res(reader.result);
            })
        },
        changeFileToArrayBuffer() {
            return new Promise((res) => {
                if (this.fileArrayBuffer)
                    res(this.fileArrayBuffer);
                const reader = new FileReader();
                reader.readAsArrayBuffer(this.file);
                reader.onload = () => res(reader.result);
            })
        },
        async downloadBlobDocumentCrypto(api = '') {
            this.downloadingFileForPrint = true;
            await axios.get(api, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer   ${this.getKeycloakData?.token}`
                },
            })
                .then(response => {
                    this.changeBlobToBase64(response.data).then((base64) => this.fileBase64 = base64);
                    this.validate = true
                    this.file = response.data;
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(response.data);
                    reader.onload = () => this.fileArrayBuffer = reader.result;
                })
                .catch(e => console.error(e))
                .finally(() => this.downloadingFileForPrint = false);
        }
    }
}